// Mock data for Nexalus Infotech website

export const companyInfo = {
  name: "Nexalus Infotech",
  tagline: "The Complete ELV Turnkey Solution",
  description: "Leading Systems Integrator specializing in Consultancy, Design, Deployment, and Maintenance of all ELV & ICT Systems",
  contact: {
    address: "8, Shalom park soc. B/h, Sindhvai Temple, CTM- Ramol road, Ahmedabad - 380026, India",
    phone: ["+91 9825 39 20 21", "+91 9979 59 23 19"],
    email: "nexalusinfotech@gmail.com",
    website: "nexalusinfotech.com"
  }
};

export const heroContent = {
  title: "Complete ELV & ICT Turnkey Solutions",
  subtitle: "Leading Systems Integrator providing end-to-end ELV solutions from first contact to running operation",
  description: "Uncompromisingly based on individual needs with focus on entire ELV & ICT systems for New Infrastructure Buildings",
  image: "https://images.unsplash.com/photo-1764983253036-edd0f55af679"
};

export const aboutContent = {
  vision: "To exceed the client's expectations by providing innovative, systematic and goal-orientated quality services and solutions to enable them to operate at fullest potential with competitive edge in modern industry.",
  mission: "To provide our clients with Efficient, Cost-Effective & Quality services & solutions by continuous review and improvement in our Services & Facilities taking into account the exact needs and expectations of our clients.",
  description: "Nexalus Infotech offers a wide range of ELV turnkey solutions with application, development & support systems. We are associated with well-known brands and provide ELV integration services as per customer requirements, catering to various industries. Years of experience enable us to provide immediate suggestions and comprehensive turnkey solutions."
};

export const services = [
  {
    id: 1,
    title: "ELV Turnkey Solutions",
    description: "Complete end-to-end ELV system integration from consultancy to deployment and maintenance for new infrastructure buildings.",
    icon: "Building2",
    features: ["Design & Consultancy", "Installation", "Testing & Commissioning", "Documentation"]
  },
  {
    id: 2,
    title: "ICT Systems Integration",
    description: "Comprehensive ICT infrastructure solutions based on conventional & IP network switching infrastructure.",
    icon: "Network",
    features: ["Network Design", "Infrastructure Setup", "System Integration", "Performance Optimization"]
  },
  {
    id: 3,
    title: "Maintenance & Support",
    description: "24/7 round-the-clock monitoring, preventive & corrective maintenance with customized AMC packages.",
    icon: "Wrench",
    features: ["Annual Maintenance Contracts", "Preventive Maintenance", "24/7 Support", "Remote Assistance"]
  },
  {
    id: 4,
    title: "Engineering Outsourcing",
    description: "Skilled engineering resources and outsourced personnel for your specific project requirements.",
    icon: "Users",
    features: ["Skilled Personnel", "Project-based Support", "On-site Engineers", "Flexible Engagement"]
  }
];

export const products = [
  {
    id: 1,
    title: "CCTV Surveillance Systems",
    description: "IP & Analog CCTV systems with HD cameras, NVR/DVR, and video management software for complete security coverage.",
    image: "https://images.unsplash.com/photo-1589935447067-5531094415d1",
    icon: "Camera"
  },
  {
    id: 2,
    title: "Access Control Systems",
    description: "Biometric, card-based, and facial recognition access control systems for secure facility management.",
    image: "https://images.unsplash.com/photo-1697382608786-bcf4c113b86e",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Fire Alarm Systems",
    description: "Conventional and addressable fire alarm systems with smoke detectors, heat sensors, and emergency response integration.",
    image: "https://images.unsplash.com/photo-1653353436174-a8e724190fd3",
    icon: "Flame"
  },
  {
    id: 4,
    title: "Network Infrastructure",
    description: "Structured cabling, fiber optics, switches, routers, and complete data center solutions.",
    image: "https://images.unsplash.com/photo-1584169417032-d34e8d805e8b",
    icon: "Network"
  },
  {
    id: 5,
    title: "Building Management System",
    description: "Integrated BMS for HVAC, lighting, energy management, and complete building automation.",
    image: "https://images.unsplash.com/photo-1753272691001-4d68806ac590",
    icon: "Home"
  },
  {
    id: 6,
    title: "Public Address System",
    description: "Professional audio systems for public announcements, background music, and emergency communications.",
    image: "https://images.pexels.com/photos/3831159/pexels-photo-3831159.jpeg",
    icon: "Volume2"
  },
  {
    id: 7,
    title: "SMATV & IPTV Systems",
    description: "Satellite and IP-based television distribution systems for hotels, hospitals, and residential complexes.",
    icon: "Tv"
  },
  {
    id: 8,
    title: "IT Hardware Solutions",
    description: "Servers, storage, networking equipment, workstations, and complete IT infrastructure solutions.",
    icon: "Server"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Efficiently Utilize Resources",
    description: "Optimal deployment and utilization of resources for maximum efficiency",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Reduce Operating Costs",
    description: "Cost-effective solutions that reduce infrastructure and operating expenses",
    icon: "DollarSign"
  },
  {
    id: 3,
    title: "Improve Revenue Realization",
    description: "Enhanced operational efficiency leading to better revenue performance",
    icon: "BarChart3"
  },
  {
    id: 4,
    title: "Enhanced Security & Safety",
    description: "State-of-the-art security and safety measures for complete peace of mind",
    icon: "ShieldCheck"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Professional & Friendly Staff",
    description: "Highly skilled, licensed, trained, and qualified engineers with years of hands-on experience",
    icon: "Users"
  },
  {
    id: 2,
    title: "Training & Technology",
    description: "Up-to-date with latest technologies and continuous training for our team",
    icon: "GraduationCap"
  },
  {
    id: 3,
    title: "One Stop Shop Approach",
    description: "Complete turnkey solutions from consultancy to maintenance under one roof",
    icon: "Package"
  },
  {
    id: 4,
    title: "Proven Track Record",
    description: "Successfully delivered projects for national and international brands",
    icon: "Award"
  },
  {
    id: 5,
    title: "Honest Transparent Pricing",
    description: "Cost-effective solutions with clear, transparent pricing and no hidden costs",
    icon: "FileText"
  },
  {
    id: 6,
    title: "Market-Leading After-Sales",
    description: "24/7 support, preventive maintenance, and quick response to service calls",
    icon: "Headphones"
  }
];

export const industries = [
  {
    id: 1,
    title: "Hospitality",
    description: "Hotels, Resorts, Restaurants",
    icon: "Hotel"
  },
  {
    id: 2,
    title: "Healthcare",
    description: "Hospitals, Clinics, Medical Centers",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Real Estate",
    description: "Residential Complexes, Villas, Apartments",
    icon: "Building"
  },
  {
    id: 4,
    title: "Corporate",
    description: "Offices, Business Parks, IT Centers",
    icon: "Briefcase"
  },
  {
    id: 5,
    title: "Industrial",
    description: "Factories, Manufacturing Units, Warehouses",
    icon: "Factory"
  },
  {
    id: 6,
    title: "Government",
    description: "Government Buildings, Public Facilities",
    icon: "Landmark"
  }
];

export const partners = [
  "CommScope", "Cisco", "D-Link", "Canon", "tp-link", "UNV",
  "Dahua Technology", "AE Connect", "Hikvision", "Dell EMC",
  "CP Plus", "Dell", "Honeywell", "HP", "Netgear", "ZKAccess"
];

export const stats = [
  { id: 1, value: "15+", label: "Years Experience" },
  { id: 2, value: "500+", label: "Projects Completed" },
  { id: 3, value: "200+", label: "Happy Clients" },
  { id: 4, value: "24/7", label: "Support Available" }
];
